import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ElementRef,
  Output,
  EventEmitter,
  ViewContainerRef
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";

import { ISubscription } from "rxjs/Subscription";

import { SiteNavNewEnum } from '@fs/enums/site-nav-new';
import { BodyBoxState } from "@fs/enums/body-box-state";
import { Tabs } from "src/app/enums/tab.enum";
import { ActionName } from "@shared/enums/action-name";
import { CustomerService } from '@fs/services/customer';
import { TabOpenService } from "src/app/services/tab-open.service";
import { CommonService } from "@shared/services/common";
import { AuthService } from "src/app/services/auth.service";
import { CommonMethods } from "src/app/services/common.method";
import { BillingDetailModel } from "src/app/fs-lte/models/customer/billing-detail.model";
import { JobSiteDetailModel } from "src/app/fs-lte/models/customer/job-site-detail-model";
import { ContactInfoModel } from "src/app/fs-lte/models/customer/contact.info.model";
import { PermissionPipe } from "@shared/pipes/permission";
import { NotificationsService } from "@shared/services/notification";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { PopupOptions } from "@fs/models/popup-options.model";

declare var google;

@Component({
  selector: "app-jobsite-create",
  templateUrl: "./jobsite-create.component.html",
  styleUrls: ["./jobsite-create.component.scss"],
  providers: [CustomerService]
})
export class JobsiteCreateComponent implements OnInit {
  //#region Input/Output
  @Input() jobSitePrimaryContactInfo: any; // received during job site editing
  @Input() currentlySelectedJobSite: any; // received during job site editing
  @Input() customerDetail: any; // received during job site editing

  @Input("popupMode") popupMode: boolean;
  @Input() copyJobSiteInfo: any = { firstname: true, lastname: true }
  @Output("saveResult") saveResult = new EventEmitter();
  @Output() closeEditCustomerModal = new EventEmitter();
  @Input() tabCounter: number;
  @Input() destroyTab: boolean;
  @Input() customerEditInfo: any;

  //#endregion
  //#region Variable Declarations
  private subscriptions: ISubscription[] = [];
  public isUnsavedTriggered: boolean = false;
  public HiddenSidePills: SiteNavNewEnum[] = [];
  /**used for adding class to div based on number */
  public mode: number = 0;
  public expandedBox: SiteNavNewEnum[] = [
    SiteNavNewEnum.ContactInformation,
    SiteNavNewEnum.SiteInformation
  ];
  public bodyBoxState = BodyBoxState;
  public siteNavNewEnum = SiteNavNewEnum;

  public newCustomerForm: FormGroup;
  //public tabCounter: number;
  public actionName = ActionName;
  public inputParams: any; // in case form is new jobsite contains customer id and complete customer detail with jobsites
  public CustomerDisplayName: string = "";
  public companyData: any;
  public isActive: boolean = false;
  public hasWorkOrderCreatePermission: boolean = true;
  public popupOptions: PopupOptions = new PopupOptions();
  //#endregion

  //#region Constructor
  constructor(
    private toastr: NotificationsService,
    private frmbuilder: FormBuilder,
    private httpCustomer: CustomerService,
    private commonMethods: CommonMethods,
    private httpCommon: CommonService,
    private changeDetector: ChangeDetectorRef,
    private auth: AuthService,
    private tabopen: TabOpenService,
    private permissionPipe: PermissionPipe,
    private elementRef: ElementRef,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef
  ) {

  }
  //#endregion

  //#region Lifecycle Events
  ngOnInit() {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    let subscription = this.httpCommon
      .GetIntialData(
        this.auth.getCompanyId(),
        //"Plan,ServiceAreas,Users,PaymentTerms,TaxGroups,LeadSources,JobSiteClasses, CodeTypeData"
        "TaxGroups"
      )
      .subscribe(response => {
        this.companyData = response;
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      }, (error: any) => { this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter); });
    this.subscriptions.push(subscription);


    if (this.customerDetail != null) {
      // input parameter contains customer detail both in case of editing and new jobsite
      this.inputParams = {
        ID: this.customerDetail.ID,
        DetailData: this.customerDetail
      };
    }
    if (this.currentlySelectedJobSite == null) {
      // new job site
      this.CreateForm();
    } // edit jobsite
    else
      this.EditForm(
        this.currentlySelectedJobSite,
        this.jobSitePrimaryContactInfo
      );

    subscription = this.tabopen.ConfirmDestroyTabEvent.subscribe(
      response => {
        if (response.tabCounter == this.tabCounter) {
          this.CreateJobSite(false, true);
        }
      }
    );
    this.subscriptions.push(subscription);

    subscription = this.tabopen.destroyModalEvent.subscribe(response => {
      if (
        response.tabCounter == this.tabCounter &&
        response.event == "destroy"
      ) {
        this.newCustomerForm.markAsPristine();
        this.tabopen.unsavedChangedDetected({
          dirty: false,
          Index: this.tabCounter
        });
        this.isUnsavedTriggered = false;
        this.closeEditCustomerModal.emit(false); // hide modal popup
      } else if (
        response.tabCounter == this.tabCounter &&
        response.event == "save"
      ) {
        setTimeout(() => {
          this.CreateJobSite(false, false);
        }, 200);
      }
    });
    this.subscriptions.push(subscription);

    subscription = this.newCustomerForm.controls["siteForm"]
      .get("ZipCode")
      .valueChanges.subscribe(() => {
        this.changeDetector.detectChanges();
      });
    this.subscriptions.push(subscription);

    if (this.inputParams != null) {
      this.CustomerDisplayName = this.inputParams.DetailData.DisplayName;
    } else {
    }

    this.hasWorkOrderCreatePermission = this.permissionPipe.transform(ActionName.NewWorkOrder);
  }
  ngOnChanges() {
    if (this.popupMode != undefined) {
      if (this.popupMode) {
        this.mode = 1;
      }
    }
  }
  ngAfterViewInit() {
    if (this.popupMode != undefined) {
      if (this.popupMode) {
        this.commonMethods.SetModalHeightWhenScrolled("#modal_container_" + this.tabCounter, $("#mainContainer")[0], this.popupOptions);
      }
    }
  }
  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      if (this.newCustomerForm != undefined && this.newCustomerForm != null) {
        let isDirty = this.newCustomerForm.dirty;
        if (isDirty) {
          this.isUnsavedTriggered = true;
          this.tabopen.unsavedChangedDetected({
            dirty: isDirty,
            Index: this.tabCounter
          });
        }
      }
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }
  //#endregion

  //#region Public Methods
  public CloseTab() {
    this.tabopen.DestroyTab(this.tabCounter);
  }
  public ToggleBoxes(data: any) {
    this.expandedBox = [];
    let me = this;
    setTimeout(() => {
      if (data.constructor === Array) {
        me.expandedBox = data;
        setTimeout(() => {
          if (
            $(me.elementRef.nativeElement)
              .find("input.ng-invalid,select.ng-invalid,input.custom-invalid")
              .first()
              .offset().top < 90
          )
            $("#mainContainer").scrollTop($("#mainContainer").scrollTop() - 90);
          let ng_elements = $(me.elementRef.nativeElement)
            .find("input.ng-invalid,select.ng-invalid")
            .first();
          if (ng_elements.length > 0) {
            ng_elements.focus();
          } else {
            let cust_elements = $(me.elementRef.nativeElement)
              .find("input.custom-invalid")
              .first();
            if (cust_elements.val() == "") cust_elements.focus();
          }
        }, 500);
      } else {
        me.expandedBox.push(data);
      }
    }, 200);
  }
  public CloseEditModal() {
    this.closeEditCustomerModal.emit(this.newCustomerForm.dirty);
  }
  //#endregion

  //#region Private Methods
  private GetLatitude_Longitude(StreetNo: string, postalCode: string) {
    return new Promise(function (resolve) {
      var result = [];
      var geocoder = new google.maps.Geocoder();
      var address = StreetNo;
      geocoder.geocode(
        {
          address: address,
          componentRestrictions: {
            postalCode: postalCode
          }
        },
        function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            var latitude = results[0].geometry.location.lat();
            var longitude = results[0].geometry.location.lng();
            result.push(latitude.toString());
            result.push(longitude.toString());
            resolve(result);
          } else {
            result.push("0");
            result.push("0");
            resolve(result);
          }
        }
      );
    });
  }

  public async CreateJobSite(isCreateNewWorkOrder: Boolean, istabClosed: Boolean = false) {
    let isSaved = false;
    if (this.newCustomerForm.valid) {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      let submitValues = Object.assign({}, this.newCustomerForm.value);
      let siteInformationModel: BillingDetailModel = new BillingDetailModel(); // site information
      let siteContactModel: ContactInfoModel = new ContactInfoModel(); // site contact

      siteInformationModel.JobSites = [Object.assign({}, submitValues.siteForm)];
      siteInformationModel.JobSites[0].IsActive = this.isActive;
      siteInformationModel.JobSites[0].Type = Object.assign({}, { ID: submitValues.siteForm.Type, Code: "", Name: "" });
      siteInformationModel.JobSites[0].ServiceArea = null;
      siteInformationModel.JobSites[0].TaxGroup = { ID: submitValues.siteForm.TaxGroup };
      siteInformationModel.JobSites[0].Comment = submitValues.siteForm.Comment;
      siteInformationModel.JobSites[0].SiteClass = null;
      siteInformationModel.JobSites[0].ModifyDate = submitValues.siteForm.ModifyDate;
      siteInformationModel.JobSites[0].MappingID = (<FormGroup>this.newCustomerForm.controls['siteForm']).controls["MappingID"].value;
      
      // find latitude and longitude again to cross verify
      const coordinates = await this.GetLatitude_Longitude(
        siteInformationModel.JobSites[0].StreetNo,
        siteInformationModel.JobSites[0].ZipCode
      );
      siteInformationModel.JobSites[0].Latitude = coordinates[0];
      siteInformationModel.JobSites[0].Longitude = coordinates[1];

      siteContactModel.FirstName = submitValues.ContactForm.FirstName;
      siteContactModel.LastName = submitValues.ContactForm.LastName;
      siteContactModel.IsPrimary = true;
      siteContactModel.IsDirty = this.newCustomerForm.controls["ContactForm"]["dirty"];

      let phoneNumberObj = {
        ID: "",
        IsDirty: this.newCustomerForm.controls.ContactForm["controls"]["PhoneDescription"].dirty || this.newCustomerForm.controls.ContactForm["controls"]["PhoneNumber"].dirty || this.newCustomerForm.controls.ContactForm["controls"]["Type"].dirty,
        IsUsedForSMS: true,
        Type: { ID: submitValues.ContactForm.Type, Code: "", Name: "" },
        PhoneNumber: submitValues.ContactForm.PhoneNumber,
        Description: submitValues.ContactForm.PhoneDescription
      };
      let emailObj = {
        ID: "",
        IsDirty: this.newCustomerForm.controls.ContactForm["controls"]["EmailAddress"].dirty || this.newCustomerForm.controls.ContactForm["controls"]["EmailDescription"].dirty,
        IsUsedForEmail: true,
        EmailAddress: submitValues.ContactForm.EmailAddress,
        Description: submitValues.ContactForm.EmailDescription
      };
      let isFormEdited = false;
      let responseMessageSubPartTextPast: string = " created";
      let responseMessageSubPartTextPresent: string = " create";
      if (this.currentlySelectedJobSite != null) {
        // update case
        isFormEdited = true;
        responseMessageSubPartTextPast = " updated";
        siteInformationModel.JobSites[0].ID = this.currentlySelectedJobSite.ID;
        siteContactModel.ID = this.jobSitePrimaryContactInfo.ID;
        phoneNumberObj.ID = submitValues.ContactForm.PhoneID;
        emailObj.ID = submitValues.ContactForm.EmailID;

      }
      siteContactModel.PhoneNumbers = [Object.assign({}, phoneNumberObj)];
      siteContactModel.Emails =
        submitValues.ContactForm.EmailAddress != ""
          ? [Object.assign({}, emailObj)]
          : null;

      siteInformationModel.JobSites[0].Contacts = [
        Object.assign({}, siteContactModel)
      ];

      let subscription = this.httpCustomer
        .CreateorUpdateJobSite(
          this.inputParams.ID, // customer id in case of both new job site and edit job site
          siteInformationModel.JobSites[0], // job site form, new or edited
          isFormEdited // true means update else new job site
        )
        .subscribe(
          response => {
            if ($(this.elementRef.nativeElement).find(".tabs__content__box").hasClass("dirty")) {
              $(this.elementRef.nativeElement)
                .find(".tabs__content__box")
                .removeClass("dirty");
            }

            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success("Job Site " +
              (<FormGroup>this.newCustomerForm.controls["siteForm"]).controls["DisplayName"].value +
              responseMessageSubPartTextPast + ".",
              "Success!"
            );

            //#region Mark Form as Pristine after saving form in edit/ new form
            this.newCustomerForm.markAsPristine(); // to avoid ngdocheck isDirty check
            //#endregion

            if (this.mode == 1) {
              this.saveResult.emit(response);
              isSaved = true;
              if (istabClosed) {
                // complete tab closed
                setTimeout(() => {
                  this.tabopen.DestroyTab(this.tabCounter);
                }, 100);
              } else {
                this.tabopen.unsavedChangedDetected({
                  dirty: false,
                  Index: this.tabCounter
                });
                this.isUnsavedTriggered = false;
              }
              return isSaved;
            }

            if (isCreateNewWorkOrder && this.permissionPipe.transform(this.actionName.NewWorkOrder)) {
              this.tabopen.ReplaceTab({
                CurrentTabIndex: this.tabCounter,
                newTabInfo: {
                  tabId: Tabs.FsLiteWorkOrderCreate,
                  params: {
                    data: {
                      ID: this.inputParams.ID,
                      DisplayName: this.inputParams.DetailData.DisplayName,
                      StreetNo: this.inputParams.DetailData.StreetNo,
                      City: this.inputParams.DetailData.City,
                      State: this.inputParams.DetailData.State,
                      ZipCode: this.inputParams.DetailData.ZipCode,
                      Unit: this.inputParams.DetailData.Unit,
                      JobSites: [Object.assign({}, response)]
                    }
                  },
                  tabTitle: "New Work Order"
                }
              });
            } else {
              setTimeout(() => {
                this.tabopen.DestroyTab(this.tabCounter);
              }, 100);
            }
          },
          exception => {
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            if (exception.error != null) {
              let displayName = (<FormGroup>(
                this.newCustomerForm.controls["siteForm"]
              )).controls["DisplayName"].value;

              if (
                exception.error.Message.toLowerCase().indexOf(
                  "display name is already used for another job site."
                ) > -1
              ) {
                this.toastr.showMultiLineError(
                  "Job Site " +
                  displayName +
                  " failed to " +
                  responseMessageSubPartTextPresent +
                  " as " +
                  exception.error.Message,
                  "Error"
                );
                (<FormGroup>this.newCustomerForm.controls["siteForm"]).controls[
                  "DisplayName"
                ].setErrors({ DuplicateName: true });
                this.OnSubmitError(true);
              } else if (
                exception.error.Message.toLowerCase().indexOf(
                  "display name is already used for another customer."
                ) > -1
              ) {
                this.toastr.showMultiLineError(
                  "Job Site " +
                  displayName +
                  " failed to " +
                  responseMessageSubPartTextPresent +
                  " as " +
                  exception.error.Message,
                  "Error"
                );
                this.OnSubmitError(true);
              } else {
                this.toastr.showMultiLineError(
                  "Job Site " +
                  displayName +
                  " failed to " +
                  responseMessageSubPartTextPresent +
                  " as " +
                  exception.error.Message,
                  "Error"
                );
              }
            } else {
              this.toastr.showMultiLineError("Something went wrong!", "Error");
            }
            return isSaved;
          }
        );
      this.subscriptions.push(subscription);
    } else {
      this.OnSubmitError(true);
      return isSaved;
    }
  }

  private OnSubmitError(IsBillingContactFormValid: boolean) {
    if (!this.newCustomerForm.controls["siteForm"].valid)
      this.ToggleBoxes([SiteNavNewEnum.SiteInformation]);
    else if (!this.newCustomerForm.controls["ContactForm"].valid)
      this.ToggleBoxes([SiteNavNewEnum.ContactInformation]);
    else if (!IsBillingContactFormValid)
      this.ToggleBoxes([SiteNavNewEnum.ContactInformation]);
    this.commonMethods.markFormGroupTouched(this.newCustomerForm);
  }

  private CreateForm() {
    let JobSiteDetail = new JobSiteDetailModel();
    let contactModel: ContactInfoModel = new ContactInfoModel();
    this.newCustomerForm = this.frmbuilder.group({
      siteForm: this.commonMethods.createFSLiteJobSiteForm(JobSiteDetail),
      ContactForm: this.commonMethods.createFSLiteJobsiteContactForm(
        contactModel
      )
    });
  }
  private EditForm(jobsiteForm: any, jobsiteContactForm: any) {
    let contactModel: ContactInfoModel = new ContactInfoModel();
    contactModel =
      jobsiteContactForm != null && jobsiteContactForm != undefined
        ? jobsiteContactForm
        : contactModel;
    this.newCustomerForm = this.frmbuilder.group({
      siteForm: this.commonMethods.createFSLiteJobSiteForm(jobsiteForm),
      ContactForm: this.commonMethods.createFSLiteJobsiteContactForm(
        contactModel
      )
    });
    this.isActive = <boolean>(this.newCustomerForm.controls["siteForm"].get("IsActive").value);
  }
  //#endregion
}
